// extracted by mini-css-extract-plugin
export var iconContainer = "styles-module--iconContainer--2Opt6";
export var itemContainer = "styles-module--itemContainer--3CnZi";
export var listItem = "styles-module--listItem--3CtK7";
export var mainContent = "styles-module--mainContent--24t2T";